import { FETCH_AUDIENCE_SUCCESS } from '../actions/audience';

const initialState = {
  items: [],
  isLoading: false,
  error: null,
};

const audienceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'FETCH_AUDIENCE_START':
      return {
        ...state,
        isLoading: true,
        error: null,
      };
    case FETCH_AUDIENCE_SUCCESS:
      return {
        ...state,
        items: action.payload,
        isLoading: false,
      };
    case 'FETCH_AUDIENCE_FAILURE':
      return {
        ...state,
        isLoading: false,
        error: action.error,
      };
    default:
      return state;
  }
};

export default audienceReducer;
